import React, { Context } from 'react';
import { AuthTokenData } from './AuthTokenData';

export class KeycloakContextHolder {
  tokenData?: AuthTokenData = undefined;

  private constructor() {}

  static create(tokenData?: Nullable<AuthTokenData>): KeycloakContextHolder {
    const kch = new KeycloakContextHolder();
    kch.tokenData = tokenData || undefined;
    return kch;
  }
}

export const KeycloakContext: Context<KeycloakContextHolder> = React.createContext(
  KeycloakContextHolder.create(),
);
